import * as angular from "angular";
import * as _ from "lodash";
import {AddressesService} from "../../addresses/services/addresses-service.factory";
import {PhoneAndEmailFactoryService} from "../../commons/services/phone-and-email-factory.service";

export class DepotsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log) {
  }

// ******************************
// External methods
// ******************************

  createDepot(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/depot-details-dialog.html').default,
      controller: function ($scope, splitService, phoneAndEmailFactoryService: PhoneAndEmailFactoryService, $filter, addressesService: AddressesService) {


        const country = splitService.getCountryCode();

        $scope.header = 'Create Depot';
        $scope.action = 'Create';
        $scope.isCreate = true;
        $scope.depot = {
          name: undefined,
          phoneNumber: undefined,
          address: {}
        };
        $scope.customAddressEnabled = false;
        $scope.addMarker = {enabled: false};

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onPhoneChange = (mobilePhone, form) => {
          phoneAndEmailFactoryService.phoneFormValidation(mobilePhone, country, form, 'phoneNumber');
          // phoneAndEmailFactoryService.phoneFormValidationAndExists(mobilePhone, country, form, 'phoneNumber');
        }

        $scope.onColorChange = (color) => {
          $scope.depot.displayColor = color;
        }

        $scope.onAddressChange = (address) => {
          $scope.depot.address = address;
        }

        $scope.onLocationButtonToggle = () => {
          $scope.addMarker.enabled = !$scope.addMarker.enabled;
        }

        $scope.onToggleCustomAddress = () => {
          $scope.customAddressEnabled = !$scope.customAddressEnabled;
          $scope.addMarker.enabled = $scope.customAddressEnabled;
          if (!$scope.customAddressEnabled) {
            $scope.addMarker.enabled = false;
          }
        }

        $scope.onDepotLocationSelect = (location) => {
          if (!$scope.depot.address) {
            $scope.depot.address = {}
          }
          $scope.depot.address.location = addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              $scope.depot.phoneNumber = $filter('bringozPhonePrefix')($scope.depot.phoneNumber);
              self.$mdDialog.hide($scope.depot);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editDepot(event, depot) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/depot-details-dialog.html').default,
      controller: function ($scope, splitService, phoneAndEmailFactoryService: PhoneAndEmailFactoryService, $filter, addressesService: AddressesService) {

        const country = splitService.getCountryCode();

        $scope.header = 'Edit Depot';
        $scope.action = 'Update';
        $scope.depot = angular.copy(depot);
        $scope.depot.phoneNumber = $filter('bringozPhone')($scope.depot.phoneNumber);
        $scope.customAddressEnabled = false;
        $scope.addMarker = {enabled: false};

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onPhoneChange = (mobilePhone, form) => {
          phoneAndEmailFactoryService.phoneFormValidation(mobilePhone, country, form, 'phoneNumber');
        }

        $scope.onColorChange = (color) => {
          $scope.depot.displayColor = color;
        }

        $scope.onAddressChange = (address) => {
          $scope.depot.address = address;
        }

        $scope.onLocationButtonToggle = () => {
          $scope.addMarker.enabled = !$scope.addMarker.enabled;
        }

        $scope.onToggleCustomAddress = () => {
          $scope.customAddressEnabled = !$scope.customAddressEnabled;
          $scope.addMarker.enabled = $scope.customAddressEnabled;
          if (!$scope.customAddressEnabled) {
            $scope.addMarker.enabled = false;
          }
        }

        $scope.onDepotLocationSelect = (location) => {
          if (!$scope.depot.address) {
            $scope.depot.address = {}
          }
          $scope.depot.address.location = addressesService.getAddressLocation(location.lat, location.lng);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              $scope.depot.phoneNumber = $filter('bringozPhonePrefix')($scope.depot.phoneNumber);
              self.$mdDialog.hide($scope.depot);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  addDepot(event, avoidIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-depot-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      bindToController: true,
      controllerAs: 'vm',
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.selectedDepotId = undefined;
        $scope.avoidIds = avoidIds;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////////////////

        $scope.onDepotSelect = (depot) => {
          $scope.depot = depot;
          $scope.selectedDepotId = _.get(depot, 'id');
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.depot);
        }

      }
    });
  }

  addDepots(event, avoidIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-depots-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      bindToController: true,
      controllerAs: 'vm',
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.selectedDepotsIds = [];
        $scope.avoidIds = avoidIds;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////////////////

        $scope.onDepotsSelect = (depots) => {
          $scope.selectedDepotsIds = depots;
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.selectedDepotsIds);
        }

      }
    });
  }
}

angular
  .module('bringoz.admin.depots')
  .service('depotsDialogService', DepotsDialogService);
